module.exports = __webpack_public_path__ + "img/logo.56b74587.svg";